import { ReactComponent as CheckmarkCircleIcon } from 'assets/checkmark-circle.svg';
import { ReactComponent as CloseCircleIcon } from 'assets/close-circle-icon.svg';

export interface PermissionCellProps {
  permission: boolean | string;
}

export const PermissionCell = ({ permission }: PermissionCellProps) => {
  if (typeof permission === 'string') {
    return <td className='table__cell table__cell--permission table__cell--permission-text'>{permission}</td>;
  }

  if (permission) {
    return (
      <td className='table__cell table__cell--permission table__cell--permission-success'>
        <CheckmarkCircleIcon />
      </td>
    );
  }

  return (
    <td className='table__cell table__cell--permission table__cell--permission-error'>
      <CloseCircleIcon />
    </td>
  );
};

export default PermissionCell;
